/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Cannot_Share_PrivateInputs */

const en_dialog_cannot_share_private = /** @type {(inputs: Dialog_Cannot_Share_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cannot share private audio`)
};

const es_dialog_cannot_share_private = /** @type {(inputs: Dialog_Cannot_Share_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se puede compartir audio privado`)
};

/**
* | output |
* | --- |
* | "Cannot share private audio" |
*
* @param {Dialog_Cannot_Share_PrivateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_cannot_share_private = /** @type {((inputs?: Dialog_Cannot_Share_PrivateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Cannot_Share_PrivateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_cannot_share_private(inputs)
	return en_dialog_cannot_share_private(inputs)
});